import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';
import Utils from '../../../../utils';
import RoutesUtils from '../../../../utils/routes';
import { RoutePath } from '../../../../routes/constants';
import HeaderLogo from '../../../../components/MenuManager/Header/Logo';

const mapStateToProps = (state: StoreState) => {
	const { galleryInfos, offlineManager, appInfos, routerParamsHistory } = state;
	const isMultiApp = Utils.isMultiApp(appInfos);
	const brandLogoUrl = Utils.getBrandLogoUrl(galleryInfos, offlineManager, false, isMultiApp);
	const brandUrl = galleryInfos.template && galleryInfos.template.brand && galleryInfos.template.brand.url;
	const currentRoute = routerParamsHistory[routerParamsHistory.length - 1];
	const isCurrentPageHome = RoutesUtils.doesRoutesContainsPath(RoutePath.Home, currentRoute.routes);

	return {
		brandLogoUrl,
		brandUrl,
		isCurrentPageHome
	};
};

export default connect(mapStateToProps)(HeaderLogo);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Header/Logo/index.tsx